import { render } from "./bank.configuration.vue?vue&type=template&id=3073d274"
import script from "./bank.configuration.vue?vue&type=script&lang=js"
export * from "./bank.configuration.vue?vue&type=script&lang=js"

import "./bank.configuration.vue?vue&type=style&index=0&id=3073d274&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__